import { configureStore } from '@reduxjs/toolkit'
import korzinaSlice from './korzinaSlice'
import { seedlingsDataSlice } from './seedlingData'

export const store = configureStore({
  reducer: {
    korzina: korzinaSlice,
    seddlingData: seedlingsDataSlice
  },
})